import AdminLayout from "./AdminLayout";
import LoadingScreen from "./LoadingScreen";
import LoginScreen from "./LoginScreen";
import useAuth from "./useAuth";

const AdminApp = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadingScreen />;
  }

  return user ? <AdminLayout /> : <LoginScreen />;
};

export default AdminApp;